import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import { colors } from "../../constants"
import facebookIcon from "../../../images/facebook-brands.svg"
import instagramIcon from "../../../images/instagram-brands.svg"
import twitterIcon from "../../../images/twitter-square-brands.svg"

const LinkText = styled.a({
  padding: "5px",
  transition: "opacity 150ms ease",
  "&:hover": {
    cursor: "pointer",
    opacity: 0.6,
  },
})

const Text = styled.span(
  {
    fontFamily: "Avenir Next",
  },
  props => ({
    fontWeight: props.fontWeight,
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
  })
)

export default class Footer extends Component {
  render() {
    return (
      <GridWrapper height={250} backgroundColor={colors.brand}>
        <Grid>
          <Grid>
            <Text fontSize={24} fontWeight={"bold"}>
              Contact us
            </Text>
            <br />
            <Text>mail: katahirasemi2020shinkan@gmail.com</Text>
          </Grid>
          <RowGrid style={{ padding: "10px" }}>
            <LinkText
              href="https://www.facebook.com/katahiraseminar/"
              target="_blank"
            >
              <img
                src={facebookIcon}
                style={{ width: "30px", color: "#3B5998" }}
              />
            </LinkText>
            <LinkText
              href="https://www.instagram.com/katahirasemi20/"
              target="_blank"
            >
              <img src={instagramIcon} style={{ width: "30px" }} />
            </LinkText>
            <LinkText href="https://twitter.com/katahirasemi20" target="_blank">
              <img
                src={twitterIcon}
                style={{ width: "30px", color: "#55acee" }}
              />
            </LinkText>
          </RowGrid>
          <Grid style={{ padding: "10px" }}>
            <Text>Copyright© 2019 @katahira All Rights Reserved.</Text>
          </Grid>
        </Grid>
      </GridWrapper>
    )
  }
}
